import { useState } from "react"
import Icon from "../Icon/Icon"

interface CollapsableProps {
    children: JSX.Element | JSX.Element[]
    headerComponent?: JSX.Element
    headerClicked?: () => void
    title?: string
    showBorderOnOpen?: boolean
    subHeaderComponent?: JSX.Element
}
export const Collapsable: React.FC<CollapsableProps> = ({ children, headerComponent, title, showBorderOnOpen, subHeaderComponent, headerClicked }) => {
    const [isOpen, setIsOpen] = useState(false)
    return (
        <div className={`grid grid-cols-12 w-full items-center   ${(isOpen && showBorderOnOpen) ? 'border !border-gray-700' : ''}`} >
            <div className="col-span-12 md:px-4 px-0 pr-1  cursor-pointer hover:bg-gray-800" onClick={() => {
                setIsOpen(actualState => !actualState)
                headerClicked && headerClicked()
            }}>
                <h1 className='text-sm font-normal truncate flex flex-row items-center gap-2'>
                    {isOpen ? <Icon name="caret-up" size={12} className="text-gray-400 hidden md:block" /> : <Icon name="caret-down" size={12} className="text-gray-400 hidden md:block" />}
                    {headerComponent ? headerComponent : title}
                </h1>
            </div>
            {subHeaderComponent}
            <div className={`grid grid-cols-12 col-span-12 gap-4 transition-all duration-800 bg-gray-950 overflow-hidden ${isOpen ? "h-full max-h-[600px]" : "h-0 max-h-0"}`} >
                {children}
            </div>
        </div >

    )
}